import ProductGallery from "./components/ProductGallery.vue"
import ProductCarusel from "./components/ProductCarusel.vue"
import AddToCartButton from "@/common/components/cart/AddToCartButton.vue"

export default [
    {
        component: ProductGallery,
        element: 'ProductGallery'
    },
    {
        component: ProductCarusel,
        element: 'ProductCarusel'
    },
    {
        component: AddToCartButton,
        element: 'AddToCartButton'
    }

];